/* globals cpac, $, $j, Windows, CcSwipeCatcher, showAjaxStarted, showAjaxFinished, Ajax, reportAjaxError, messageBox */

if (typeof cpac !== 'undefined') {
  cpac.payment = {
    addBatchRow: function () {
        try {
            var num = $('payment-batch-rows-count').getValue();
            var row = $('payment_batch_list_row_' + num);
            if (row) {
                var regex = new RegExp('_' + num, 'mig');
                var proto = row.innerHTML + '';
                num++;
                var clone = '<tr class="transaction_row last" id="payment_batch_list_row_' + num + '">';
  
                clone += proto.replace(regex, '_' + num);
                clone += '</tr>';
  
  
                $('payment-batch-rows-count').setValue(num);
                row.insert({
                    after: clone
                });
                $('batch_row_' + num).setValue('');
                $('batch_row_id_' + num).setValue('');
                $('custom_description_' + num).setValue('');
  
                $j('#payment_batch_list_row_' + num).find('.field.batch_row').on('blur', cpac.payment.initAccGroupSelected);
            }
        }
        catch (e) {
            cpac.error(e)
        }
    },
  
    initAccGroupSelected: function() {
        var accGroupName = $j(this).attr('data-name');
        if (typeof accGroupName !== 'undefined') {
            var $description = $j(this).closest('tr').find('.field.custom_description');
            if ($description.length > 0) {
                if ($description.attr('placeholder') === '') {
                    $description.attr('placeholder', accGroupName);
                }
            }
        }
    }
  };  

  cpac.payment.catchTrack = function( userId ) {
    if (this.trackCatcher == null) {
        this.trackCatcher = new CcSwipeCatcher({
            onComplete: function(isOk, obj) {
                if(isOk) {
                    var win = new Window({
                        className: 'alphacube',
                        title: 'Confirm',
                        width: 330,
                        height: 110,
                        closable: true,
                        resizable: false,
                        minimizable: false,
                        maximizable: false,
                        destroyOnClose: true
                    });
                    win.getContent().insert([
                        '<div style="padding: 10px; line-height: 24px;">'
                       ,    '<div><b>Credit card #: </b>'+obj.PAN+'</div>'
                       ,    '<div><b>Card Expiration <small>(MM/YY)</small>: </b>'+obj.expMonth+'/'+obj.expYear+'</div>'
                       ,    '<div style="margin-top: 10px;">'
                       ,        '<input type="button" value="Cancel" onclick="cpac.payment.catchTrackCancel()" class="button nicebutton" style="float: right; color: #920000;" />'
                       ,        '<input type="button" value="Save" onclick="cpac.payment.catchTrackSave()" class="button nicebutton" style="float: left; color: #6D881C;" />'
                       ,    '</div>'
                       ,    '<div style="clear: both;"></div>'
                       ,'</div>'
                       ,'<input type="hidden" id="track_win_id" value="',win.getId(),'" />'
                       ,'<input type="hidden" id="track_cc_num" value="',obj.PAN,'" />'
                       ,'<input type="hidden" id="track_cc_year" value="',obj.expYear,'" />'
                       ,'<input type="hidden" id="track_cc_month" value="',obj.expMonth,'" />'
                       ,'<input type="hidden" id="track_user_id" value="',userId,'" />'
                    ].join(''));

                    win.showCenter(true);
                }
                else {
                    alert('Swipe was not successfull!');
                }
            }.bind(this),
            bannerText: 'Waiting for swipe action...',
            cancelText: 'Cancel'
        });
    }
    this.trackCatcher.startSwipe();
}

cpac.payment.catchTrackCancel = function() {
    Windows.close( $('track_win_id').value );
}

cpac.payment.catchTrackSave = function() {
    showAjaxStarted();
    new Ajax.Request( '/payment/use-new-credit-card/?ajax=true', {
        method: 'post',
        parameters: {
            'user_id': $('track_user_id').value,
            'cc_number': $('track_cc_num').value,
            'cc_date[year]': '20' + $('track_cc_year').value,
            'cc_date[month]': $('track_cc_month').value
        },
        onComplete: function(request) {
            showAjaxFinished();
            if( request.responseText != '' ) {
                messageBox('Error', request.responseText);
            } else {
                Windows.close( $('track_win_id').value );

                var v = $j('#pos_main_screen .msgbox .content .messages a[onclick^="cpac.payment.catchTrack"]');
                if( v.length ) {
                    v.each(function(){
                        var m = $j(this).parent('.messages');
                        if( m ) m.remove();
                    })
                }
            }
        },
        onFailure: reportAjaxError
    });
}

}